import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';

import * as actions from '../actions';
import * as actionCreators from '../action-creators';
import { mergeMap } from 'rxjs/operators';
import { Actions } from '../../actions';
import * as auth from '@webapp/sdk/auth';
import { NoOp } from '../../ui/action-creators';
import { setLocalStorageItem } from '@webapp/utils/localstorage';

export const createAccountEpic = (action$: Observable<Actions>) =>
  action$.pipe(
    ofType<Actions, actionCreators.CreateAccount>(actions.CREATE_ACCOUNT),
    mergeMap((action) =>
      auth.signup(action.data).then(() => {
        const provider = action.data.phone
          ? 'Phone'
          : action.data.email
          ? 'Email'
          : undefined;
        setLocalStorageItem('provider', provider);
        return new NoOp();
      })
    )
  );
